export default function getBalanceClass(balance, isNormalized) {
  let boldClass = isNormalized ? "" : " font-weight-bold";

  if (balance < 0) {
    return "text-danger" + boldClass;
  } else if (balance !== 0) {
    return "text-success" + boldClass;
  }
}
